import React from 'react';

export default () => {
  return (
    <div className="invisible group-hover:visible text-[#DCEAF8] text-xs p-1 flex items-center justify-center ">
      |
    </div>
  );
};
